import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { activeProfileDetails, removeProfile } from "../../../store/SessionSlice";
import AuthService from "../../../services/AuthService";
import WithRoutify from "../../../hoc/WithRoutify";
import { useEffect } from "react";
import FormCompletionIllustration from "./FormCompletionIllustration";

const FormCompletionSuccessPanel = ({ isKiosk }) => (
  <div className="card sucesscontainer border-0 my-2">
    <div className="card-body">
      <div className="d-flex flex-column align-items-center text-center px-2 py-3 w-100">
        <div className="mb-2">
          <FormCompletionIllustration />
        </div>
        <h6
          className="text-lg f-500 mb-0 mt-2 text-nowrap"
          style={{ color: "#62AE47" }}
        >
          Form Completed Successfully
        </h6>
        {isKiosk ? (
          <div className="mt-3 w-100">
            <p className="text-muted mb-2 mb-md-3">
              Thank you. Please let staff know you have finished.
            </p>
            <p className="text-muted small mb-0">
              Press <strong>Exit kiosk</strong> at the top of the screen when ready to exit.
            </p>
          </div>
        ) : null}
      </div>
    </div>
  </div>
);

const FormCompletion = ({ Toast, Loader, isKiosk, ...props }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const profileDetails = useSelector(activeProfileDetails);
  useEffect(() => {
    try {
      sessionStorage.removeItem("unified_packet_just_completed");
      sessionStorage.removeItem("unified_continue_anyway_flow");
    } catch {
      /* ignore */
    }
    if (isKiosk) {
      return undefined;
    }
    const timer = setTimeout(async () => {
      try {
        sessionStorage.removeItem("unified_reentry");
        sessionStorage.removeItem("unified_reentry_manifest");
        await AuthService.logout();
      } finally {
        navigate("/login");
      }
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate, isKiosk]);

  if (isKiosk) {
    return (
      <div className="d-flex flex-column justify-content-center align-items-center py-4 px-3 w-100">
        <div className="w-100 mx-auto" style={{ maxWidth: 560 }}>
          <FormCompletionSuccessPanel isKiosk />
        </div>
      </div>
    );
  }

  const removeProfileAsync = (key) => {
    return async (dispatch, getState) => {
      const sessionState = getState().session.profileDetails;
      try {
        if (Object.keys(sessionState).length > 1) {
          await AuthService.impersonateLogout();
        }
        dispatch(removeProfile({ key }));
      } catch (e) {
        /* ignore */
      }
      const updatedState = getState().session.profileDetails;
      const keys = Object.keys(updatedState);
      try {
        if (keys.length === 0) {
          await AuthService.logout();
          navigate("/login");
        } else {
          Toast.success(profileDetails.name + " logged-out successfully");
          navigate("/organisation");
        }
      } catch (error) {
        await AuthService.logout();
      }
    };
  };

  return (
    <div className="col-lg-6 d-flex flex-column justify-content-center mx-auto">
      <div className="row">
        <div className="col-12 col-md-10 col-lg-9 mx-auto">
          <FormCompletionSuccessPanel isKiosk={false} />
        </div>
      </div>
    </div>
  );
};

export default WithRoutify(FormCompletion);
